import { Box, Modal } from "@mui/material";
import { useForm } from "react-hook-form";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import InputField from "../../../../common/components/FormFields/InputField";
import { errorAlert } from "../../../../common/components/Toasts/CustomToasts";

const NursesHandoverPasscodeModal = ({ open, onClose, onSubmit }) => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: { passcode: "" },
  });

  const onFormSubmit = (data,e) => {
      e?.stopPropagation();  // ← add karo

    if (!data?.passcode.trim()) {
      errorAlert("Please enter passcode");
      return;
    }
    onSubmit(data?.passcode);
    reset();
  };

  return (
    <Modal open={open} aria-labelledby="passcode-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 3,
          width: 420,
        }}
      >
        <div className="flex justify-between items-center pb-2">
          <h2 className="font-bold text-[15px] text-gray-800">
            Enter Passcode
          </h2>
          <CloseModalIcon type="button" onClick={onClose} />
        </div>

        <CommonDivider color="E0E0E0" />

        <form onSubmit={handleSubmit(onFormSubmit)}>
          <div className="mt-4 mb-4">
            <InputField
              control={control}
              name="passcode"
              label="Passcode"
              type="password"
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onclose}
              className="px-4 py-1.5 rounded-md border border-gray-400 text-gray-600 hover:bg-gray-100 text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-1.5 rounded-md bg-customBlue text-white hover:opacity-90 text-sm"
            >
              Submit
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default NursesHandoverPasscodeModal;